import React from 'react';
import S from './SearchCard.styles';
const SearchCard = ({ cta, summary, tag, title, type }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Link, { href: cta.url, target: cta.target },
            React.createElement(S.Inner, null,
                React.createElement(S.ContentWrapper, null,
                    tag && React.createElement(S.Tag, null, tag),
                    React.createElement(S.TitleContainer, null,
                        type === 'pdf' && React.createElement(S.FilePdfIcon, null),
                        type === 'media' && React.createElement(S.FilePlayIcon, null),
                        React.createElement(S.Title, null, title)),
                    summary && React.createElement(S.Summary, null, summary),
                    React.createElement(S.CtaHolder, null,
                        React.createElement(S.Cta, null, "Read More")))))));
};
export default SearchCard;
